import React, { useEffect, useContext } from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';

// api

// components
// import MapTool from '../map/MapTool';
import MapContainer from '../components/timelineMap/MapContainer';
import PopUpModal from '../components/timelineMap/PopUpModal';

// store
import { StoreContext } from '../store/StoreProvider';
import Act from '../store/actions';
import TimeLine from '../components/timelineMap/TimeLine';

// format points for cluster, include points and clusters
const generatePointsForCluster = (publicationData) => {
	const prePoints = [];
	publicationData.forEach((item) => {
		const lat = parseFloat(item.lat);
		const long = parseFloat(item.long);
		const found = prePoints.find(
			(info) => info.properties.position[0] === lat && info.properties.position[1] === long
		);
		if (!found) {
			prePoints.push({
				type: 'Feature',
				properties: {
					cluster: false,
					position: [lat, long],
					location: item.location,
					locId: item.locId,
					pubIds: [item.pubId],
					publication: [item.publication],
					intensity: 1,
					displayLocation: true, // 選擇要不要顯示城市名稱
				},
				geometry: {
					type: 'Point',
					coordinates: [long, lat],
				},
			});
		} else {
			found.properties.pubIds.push(item.pubId);
			found.properties.intensity += 1;
			found.properties.publication.push(item.publication);
		}
	});
	return prePoints;
};

const TimelineMap = () => {
	const [state, dispatch] = useContext(StoreContext);
	const { map, timeline } = state;
	const { fileExporting, pageLoading } = map;
	const { transMapData } = timeline;

	useEffect(() => {
		// set pointsInfo for cluster
		// console.log(transMapData);
		const points = generatePointsForCluster(transMapData);
		dispatch({
			type: Act.SET_CLUSTER_POINTS,
			clusterPoints: points,
		});

		const markerInfo = points.map((p) => p.properties);
		dispatch({
			type: Act.SET_MAP_DATA,
			mapData: markerInfo,
		});
	}, [transMapData]);

	return (
		<React.Fragment>
			<div style={{ height: 'calc(80vh - 87px)', width: '100%' }} className="map_container">
				{/* loading icon display */}
				<Dimmer active={fileExporting} inverted>
					<Loader inverted content="Downloading" size="massive" />
				</Dimmer>
				<Dimmer active={pageLoading} inverted>
					<Loader inverted content="Loading" size="massive" />
				</Dimmer>

				{/* map tool for option setting and map marker color legend */}
				{/* <MapTool /> */}

				{/* map container : SearchInput component is inside the MapContainer */}
				<MapContainer />

				{/* popUp modal */}
				<PopUpModal />
			</div>
			<TimeLine />
		</React.Fragment>
	);
};

export default TimelineMap;
